import { cusAxios, PREFIX } from './main';

const getJournalFilter = async () => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/journal_filter`
  });
  return response;
};

const getJournalList = async ({ userId, dateFrom, dateTo, pageSize, pageNo, filter, lang }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/journal`,
    data: { userId, dateFrom, dateTo, pageSize, pageNo, filter, lang }
  });
  return response;
};

const blockUsers = async ({ userList, lock }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/set_locked`,
    data: { userList, lock }
  });
  return response;
};

window.blockUsers = blockUsers;

const getFinance = async ({ userId, currency }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/finance`,
    data: { userId, currency }
  });
  return response;
};

const getIpAddress = async ({ userId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/ip_address_list`,
    data: { userId }
  });
  return response;
};

const getUsers = async (data) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/filtered_list`,
    data: data
  });
  return response;
};

const createUser = async (data) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/create_new`,
    data: data
  });
  return response;
};

const getUserInfo = async ({ userId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/info`,
    data: { userId }
  });
  return response;
};

const updateUserInfo = async ({
  userId,
  comment,
  status,
  statusComment,
  emailConfirm,
  depositEnabled,
  payoutEnabled,
  gameBetEnabled
}) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/info_update`,
    data: {
      userId,
      comment,
      status,
      statusComment,
      emailConfirm,
      depositEnabled,
      payoutEnabled,
      gameBetEnabled
    }
  });
  return response;
};

const getFinanceUserInfo = async ({ userId, currency }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/fin_info`,
    data: { userId, currency }
  });
  return response;
};

const changeUsersLogin = async ({ userId, newLogin }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/change_login`,
    data: { userId, newLogin }
  });
  return response;
};

const changeUserEmail = async ({ userId, newEmail }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/change_email`,
    data: { userId, newEmail }
  });
  return response;
};

const genPassword = async ({ length, letters, digits, symbols }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/gen_psword`,
    data: { length, letters, digits, symbols }
  });
  return response;
};

const senPassword = async ({ userId, psword }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/psword_set`,
    data: { userId, psword }
  });
  return response;
};

const getBalances = async ({ userId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/balance_list`,
    data: { userId }
  });
  return response;
};

const getDetailBalances = async ({ userId, currency }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/balance_detail`,
    data: { userId, currency }
  });
  return response;
};

const clearBalance = async ({ userId, currency, mainBalance, depositList, bonusList }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/balance_clear`,
    data: { userId, currency, mainBalance, depositList, bonusList }
  });
  return response;
};

const appendBalance = async ({ userId, currency, amount, wager }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/balance_append`,
    data: { userId, currency, amount, wager }
  });
  return response;
};

const getDepositLock = async ({ userId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/deposit_lock_get`,
    data: { userId }
  });
  return response;
};

const setDepositLock = async ({ userId, enabled }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/deposit_lock_set`,
    data: { userId, enabled }
  });
  return response;
};

const userDelete = async ({ userList }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/delete`,
    data: { userList }
  });
  return response;
};

const getRights = async ({ userId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/rights_get`,
    data: { userId }
  });
  return response;
};

const setRights = async ({ userId, rights }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/rights_set`,
    data: { userId, rights }
  });
  return response;
};

const getTgMessage = async ({ userId, fromTime, afterMsgId, setReadAll }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/botchat_get`,
    data: { userId, fromTime, afterMsgId, setReadAll }
  });
  return response;
};

const sendTgMessage = async ({ userId, msg }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/botchat_send`,
    data: { userId, msg }
  });
  return response;
};

const moveGroupUsers = async ({ userList, groupId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/user/move_to_group`,
    data: { userList, groupId }
  });
  return response;
};

export const API_USERS = {
  journal: { getFilter: getJournalFilter, list: getJournalList },
  block: blockUsers,
  finance: getFinance,
  ipAddress: getIpAddress,
  list: getUsers,
  new: createUser,
  info: {
    get: getUserInfo,
    update: updateUserInfo,
    finance: getFinanceUserInfo,
    changeLogin: changeUsersLogin,
    changeEmail: changeUserEmail,
    pas: { gen: genPassword, set: senPassword },
    balances: {
      list: getBalances,
      detail: getDetailBalances,
      clear: clearBalance,
      append: appendBalance
    },
    deposit: {
      lock: { get: getDepositLock, set: setDepositLock }
    },
    delete: userDelete,
    rights: { get: getRights, set: setRights },
    tgChat: { getMessages: getTgMessage, sendMes: sendTgMessage },
    group: { move: moveGroupUsers }
  }
};
